// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 8926 ? "react-monaco-editor" : chunkId) + "." + {"3405":"0ce669c0","6275":"3a0acbf0","8926":"62a553fe"}[chunkId] + ".chunk.css";
};